import * as React from 'react'
import type {SVGProps} from 'react'
const SvgYoutube = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={12} viewBox="0 0 18 12" {...props}>
        <path
            fill="#55449a"
            fillRule="evenodd"
            d="M17.235 1.156C16.747.314 16.217.16 15.138.1 14.06.03 11.35 0 9.002 0 6.65 0 3.94.03 2.862.1 1.785.16 1.254.312.762 1.155.259 1.997 0 3.446 0 5.996v.01c0 2.54.259 4 .762 4.832.492.842 1.022.995 2.099 1.066 1.078.061 3.789.097 6.141.097 2.348 0 5.058-.036 6.137-.096 1.079-.07 1.609-.224 2.097-1.066.508-.832.764-2.292.764-4.831v-.011c0-2.552-.256-4-.765-4.842zM6.75 9.273V2.727L12.375 6z"
        />
    </svg>
)
export default SvgYoutube
